var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 474.59,
    height: 11.52,
    viewBox: "0 0 474.59 11.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M474.46,11.52c-2.13-.08-214.89-7.76-350.58-.38l-.11-2c99.22-5.39,239.6-2.74,308.83-.89C225.12-5.89,2.51,8.37.13,8.52l-.13-2c2.54-.17,256.25-16.42,474.59,3l-.12,2Z",
    fill: "#00ceff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineBlue);
export default __webpack_public_path__ + "static/media/underline-blue.dee5c9e3abc62ea33f79adca2c5f82f6.svg";
export { ForwardRef as ReactComponent };